import { render, staticRenderFns } from "./VendorCreate.vue?vue&type=template&id=2119a50e&scoped=true&"
import script from "./VendorCreate.vue?vue&type=script&lang=js&"
export * from "./VendorCreate.vue?vue&type=script&lang=js&"
import style0 from "./VendorCreate.vue?vue&type=style&index=0&id=2119a50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119a50e",
  null
  
)

export default component.exports